import React, { useState } from "react";
import Viewer from "./Viewer";
import Keypad from "./Keypad";
import Notepad from "./Notepad";

const AnsweringQuestions = ( props ) => {

  const [ answer, setAnswer ] = useState( '' );
  const [ keypadType, setKeypadType ] = useState( 0 );

  const Inputer = keypadType ? Notepad : Keypad;

  return (
    <div style={ { padding : 20, display : 'inline-flex', width : '100%' } }>
      <Viewer question={ props.children } answer={ answer } keypadType={ keypadType } />
      <Inputer onKey={ setAnswer } onChange={ setKeypadType } />
    </div>
  );

};

export default AnsweringQuestions;
